import { getGoogleAnalyticsClientId, getGoogleAnalyticsSessionId } from "@/lib/analytics-ga4";
import { getOrCreateBootstrapDistinctId as getAnalyticsDistinctId } from "@/lib/analytics-identity";
import { isCapabilityTelemetryPath, privacySafeTelemetryUrl } from "@/lib/telemetry-route-policy";

function privacySafePaymentUrl(value: string): string {
  return isCapabilityTelemetryPath(value) ? privacySafeTelemetryUrl(value) : value;
}

/**
 * Browser page context at the moment a server-canonical payment call fires.
 * Forwarded to the backend so GA4 Measurement Protocol can attribute
 * commerce events to the buyer's actual URL/session instead of "(not set)".
 */
export function paymentPageContext(): {
  page_location: string;
  page_title: string;
  page_referrer: string;
  ga_client_id: string;
  ga_session_id: string;
} {
  if (typeof window === "undefined") {
    return {
      page_location: "",
      page_title: "",
      page_referrer: "",
      ga_client_id: "",
      ga_session_id: "",
    };
  }
  return {
    page_location: privacySafePaymentUrl(window.location.href).slice(0, 512),
    page_title: typeof document !== "undefined" ? document.title.slice(0, 300) : "",
    page_referrer:
      typeof document !== "undefined" ? privacySafePaymentUrl(document.referrer).slice(0, 420) : "",
    ga_client_id: getGoogleAnalyticsClientId() ?? "",
    ga_session_id: getGoogleAnalyticsSessionId() ?? "",
  };
}

export function paymentDistinctId(explicit?: string): string | undefined {
  return explicit ?? getAnalyticsDistinctId();
}
